<template>
  	<div>
    	<breadcrumb :items="breadcrumbs"></breadcrumb>
    	<v-container fluid>
		<div class="page-title">
			<h2 class="text-capitalize">{{ farmObj.farmName }}</h2>
			<v-spacer></v-spacer>
			<v-btn
				depressed
				color="primary"
				dark
				:to="{ name: 'EditPrimaryFarm', params: { id: farmObj.id } }"
				>
				{{$t('farm.editAfarm')}}
			</v-btn>
		</div>

      	<div class="c-right">
        <v-card flat>
			<v-card-text>
				<v-row width="100%">
					<v-col class="">
						<v-list>
						<v-list-item>
							<v-list-item-content>
							<v-list-item-subtitle>{{$t('farm.productionSystem')}}</v-list-item-subtitle>
							<v-list-item-title class="text-h6 mt-2 text-capitalize">
								{{ farmObj.productionSystem }}
							</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						</v-list>
					</v-col>
					<v-divider vertical inset></v-divider>
					<!-- <v-col class="">
						<v-list>
						<v-list-item>
							<v-list-item-content>
							<v-list-item-subtitle> {{$t('farm.farm_Owner')}} </v-list-item-subtitle>
							<v-list-item-title class="text-h6 mt-2 text-capitalize">
								{{ farmObj.farmOwner }}
							</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						</v-list>
					</v-col> -->
					<v-divider vertical inset></v-divider>
					<!-- <v-col class="">
						<v-list>
						<v-list-item>
							<v-list-item-content>
							<v-list-item-subtitle>
								#{{$t('farm.govtRegistry')}}
							</v-list-item-subtitle>
							<v-list-item-title class="text-h6 mt-2 text-capitalize">
								{{ farmObj.govRegistrationNum }}
							</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						</v-list>
					</v-col> -->
					<v-divider vertical inset></v-divider>
					<!-- <v-col class="">
						<v-list>
						<v-list-item>
							<v-list-item-content>
							<v-list-item-subtitle>
								{{$t('farm.cooperativeID')}}
							</v-list-item-subtitle>
							<v-list-item-title class="text-h6 mt-2 text-capitalize">
								{{ farmObj.cooperativeId }}
							</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						</v-list>
					</v-col> -->
					<v-divider vertical inset></v-divider>
					<v-col class="">
						<v-list>
						<v-list-item>
							<v-list-item-content>
							<v-list-item-subtitle>
								{{$t('farm.dateOfRegistration')}}
							</v-list-item-subtitle>
							<v-list-item-title class="text-h6 mt-2">
								{{ farmObj.createdAt }}
							</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						</v-list>
					</v-col>
				</v-row>
			</v-card-text>
        </v-card>
	</div>
	<template>
        <v-card class="px-5" flat>
			<v-tabs
				left
				v-model="tab"
				background-color="transparent"
				color="primary"
			>
				<v-tab l v-for="item in items" :key="item">
				{{ item }}
				</v-tab>
			</v-tabs>
          	<v-divider></v-divider>
			<v-tabs-items v-model="tab" class="mt-5">
				<v-tab-item>
					<information :farm="farmObj"></information>
				</v-tab-item>
				<v-tab-item>
					<licence :farm="farmObj" :dateFormat="format"></licence>
				</v-tab-item>
				<v-tab-item>
					<location :farm="farmObj"></location>
				</v-tab-item>
				<v-tab-item>
					<geolocation :farm="farmObj"></geolocation>
				</v-tab-item>
			</v-tabs-items>
        </v-card>
	</template>
	<!-- <div class="mt-5 mb-5">
		<div class="page-title mt-5">
			<h2>{{$t('farm.farmAnimals')}}</h2>
			<v-spacer></v-spacer>
			<v-btn
				color="primary"
				depressed
				outlined
				:to="{
					name: 'AddFarmAnimal',
					params: { farm_number: $route.params.id },
				}"
				>
				{{$t('farm.registerAnAnimal')}}
			</v-btn>
		</div>
	</div>
	<template>
        <v-card flat color="transparent">
          	<v-container class="mb-5" grid-list-xl fluid>
            	<v-layout row wrap>
					<v-flex
						xs6
						sm4
						md2
						xl2
						class="lg5-custom mb-5"
						:style="
						$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
						"
					>
						<v-card flat min-height="90">
							<div class="section-boxes1">
								<div class="boxes-data">
									<div class="box-inline-tab">
										<div class="circle-img"></div>
										<div class="box-deatils-part">
										<h2>{{$t('farm.dam')}}</h2>
										<p></p>N/a
										</div>
									</div>
									<div class="arrow-icon">
										<div class="three-dot">
										<v-icon>mdi-dots-horizontal</v-icon>
										</div>
										<v-icon>mdi-chevron-right</v-icon>
									</div>
								</div>
							</div>
						</v-card>
              		</v-flex>
              		<v-flex
						xs6
						sm4
						md2
						xl2
						:style="
						$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
						"
						class="lg5-custom mb-5"
					>
						<v-card flat min-height="90">
							<div class="section-boxes1">
								<div class="boxes-data">
									<div class="box-inline-tab">
										<div class="circle-img"></div>
										<div class="box-deatils-part">
										<h2>{{$t('farm.sire')}}</h2>
									 N/a
										</div>
									</div>
									<div class="arrow-icon">
										<div class="three-dot">
										<v-icon>mdi-dots-horizontal</v-icon>
										</div>
										<v-icon>mdi-chevron-right</v-icon>
									</div>
								</div>
							</div>
						</v-card>
              		</v-flex>
					<v-flex
						xs6
						sm4
						md2
						xl2
						:style="
						$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
						"
						class="lg5-custom mb-5"
					>
						<v-card flat min-height="90">
							<div class="section-boxes1">
								<div class="boxes-data">
								<div class="box-inline-tab">
									<div class="circle-img"></div>
									<div class="box-deatils-part">
									<h2>{{$t('farm.heifer')}}</h2>
									 N/a
									</div>
								</div>
								<div class="arrow-icon">
									<div class="three-dot">
									<v-icon>mdi-dots-horizontal</v-icon>
									</div>
									<v-icon>mdi-chevron-right</v-icon>
								</div>
								</div>
							</div>
						</v-card>
              		</v-flex>
					<v-flex
						xs6
						sm4
						md2
						xl2
						:style="
						$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
						"
						class="lg5-custom mb-5"
					>
						<v-card flat min-height="90">
						<div class="section-boxes1">
							<div class="boxes-data">
							<div class="box-inline-tab">
								<div class="circle-img"></div>
								<div class="box-deatils-part">
								<h2>{{$t('farm.steer')}}</h2>
							N/a
								</div>
							</div>
							<div class="arrow-icon">
								<div class="three-dot">
								<v-icon>mdi-dots-horizontal</v-icon>
								</div>
								<v-icon>mdi-chevron-right</v-icon>
							</div>
							</div>
						</div>
						</v-card>
					</v-flex>
					<v-flex
				
						xs6
						sm4
						md2
						xl2
						:style="
						$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
						"
						class="lg5-custom mb-5"
					>
						<v-card flat min-height="90">
						<div class="section-boxes1">
							<div class="boxes-data">
							<div class="box-inline-tab">
								<div class="circle-img"></div>
								<div class="box-deatils-part">
								<h2>{{$t('farm.calf')}}</h2>
							N/a
								</div>
							</div>
							<div class="arrow-icon">
								<div class="three-dot">
								<v-icon>mdi-dots-horizontal</v-icon>
								</div>
								<v-icon>mdi-chevron-right</v-icon>
							</div>
							</div>
						</div>
						</v-card>
					</v-flex>
            	</v-layout>
		</v-container>
	</v-card>
	</template > -->
	<!-- <div> -->
    <!-- <div class="mt-5 mb-5">
      <div class="page-title mt-5">
        <h2>{{$t('farm.farmProducts')}}</h2>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          :to="{
            name: 'AddFarmProduct',
            params: { farmId: $route.params.id },
          }"
        >
         {{$t('farm.registerAProduct')}}
        </v-btn>
      </div>
    </div> -->
    <!-- <template>
    <v-card v-if="products.length>0">
      <v-container fluid>
        <v-row>
          <v-col
            cols="4"
            v-for="item in products"
            :key="item.productNumber"
            @click="
              $router.push({
                name: 'SingleProduct',
                params: {
                  farmId: item.farmNumber,
                  productId: item.productNumber,
                },
              })
            "
          >
            <v-card max-width="344" max-height="150" outlined>
              <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
              <v-list-item>
                <v-list-item-content>
                  <div class="font-weight-black mb-4 text-capitalize">{{ 'item.name' }}</div>
                  <div class="inline">
                    <v-list-item-avatar
                      class="mb-5 float-left green2"
                      size="50"
                      dark
                    ></v-list-item-avatar>
                    <div class="mt-2">
                      <v-list-item-subtitle>{{
                        item.stockStatus
                      }}</v-list-item-subtitle>
                      <v-list-item-title class="text-h5 mb-1">
                        {{ item.stockQty }} {{ item.stockUom }}
                      </v-list-item-title>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
              </v-card>
    </template> -->
  <!-- </div> -->
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/core/Breadcrumb";
import FarmService from "@/_services/farmService";
import Licence from "./single_farm/Licence.vue";
import Information from "./single_farm/Information.vue";
import Location from "./single_farm/Location.vue";
import NtrService from "@/_services/NtrService";
import Geolocation from "./single_farm/Geolocation.vue";
// import FarmProduct from "./single_farm/FarmProduct.vue";
import loadingMixin from "@/mixins/LoadingMixin";
export default {
  components: {
    breadcrumb: Breadcrumb,
    Licence,
    Information,
    Location,
    Geolocation,
    // FarmProduct,
  },
  computed: {
    ...mapGetters(["getfarm"]),
  },
  data() {
    return {
			farmProductionSystemsObj: {},
			farmProductionSystems: [],
			farmOptions: [],
	  	farmObj: {},
      date: "",
      tab: null,
      farmID:"",
      items: [this.$t('farm.information'),
			this.$t( 'farm.licenseInfo'), 
			this.$t('farm.locationInfo'),
			 this.$t('farm.geoLocation')
		],
      animal: {},
            products: [],
      tableOptions: {
        page: 1,
        itemsPerPage: 1000,
        sortBy:""
      },
      search: "",
      farmId:"",
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('farm.farms'),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "My farm" },
        },
        {
          text: this.$route.params.id,
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
    };
  },

  async mounted() {
    await this.getItem(this.$route.params.id);
    // await this.getProduct();
  },

  methods: {
    async getItem(id) {
      this.startLoading();
			 this.farmOptions = await FarmService.getFarmOptions();
			 this.farmProductionSystems =  this.farmOptions.FarmProductionSystem;
			 this.farmProductionSystems.forEach(item => {
				this.farmProductionSystemsObj[item.id] = item.name;
			});
      FarmService.getPrimaryFarm(id)
        .then(async (response) => {
          // console.log(response);
          this.farmID=response.data.id
					this.farmObj = response.data
					this.farmObj.productionSystem = JSON.parse(this.farmObj.productionSystem)
					this.farmProductionSystems.forEach(item => {
						this.farmProductionSystemsObj[item.id] = item.name;
					});

					this.farmObj.productionSystem = this.farmObj.productionSystem.map(el => {
						return this.farmProductionSystemsObj[el]
					}).join(",")
					
          // console.log(this.farmID)
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
    goToFarm(frmNum) {
      this.$router.push({ name: "SingleFarm", params: { id: frmNum } });
    },
    format(inputDate) {
      var date = new Date(inputDate);
      if (!isNaN(date.getTime())) {
        console.log("mm", date.getMonth());
        // Months use 0 index.
        return  `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`
    }
},
getProduct(id) {
      NtrService.getfarmProducts(
        this.tableOptions,
        this.search,
        id
      )
        .then((res) => {
          console.log("res products", res);
          this.products = res.data.products.rows;
          console.log("pr", this.products);
          // this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },

  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
.c-right {
  padding: 0px 0px 50px !important;
}

.page-title p {
  color: $primary-color;
}

.section-boxes1 {
  // border-bottom: 1px solid #ccc;
  padding: 8px;
}
.section-boxes1 .boxes-data {
  display: flex;
  justify-content: space-between;
}
.section-boxes1 .box-inline-tab {
  display: flex;
  align-items: center;
}
.section-boxes1 .circle-img {
  background: paleturquoise;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.section-boxes1 .box-deatils-part {
  margin-top: 12px;
  margin-left: 14px;
}
.section-boxes1 .box-deatils-part h2 {
  font-size: 13px;
  color: grey;
}
.section-boxes1 .box-deatils-part p {
  font-size: 29px;
  margin-top: 1px;
}
.three-dot {
  margin-bottom: 9px;
}

.flex.lg5-custom {
  width: 20%;
  max-width: 80%;
  flex-basis: 20%;
}
.route {
  text-decoration: none !important;
  position: absolute;
  top: 15px;
  right: 10px;
}
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
</style>
